<span *ngFor="let breadcrumb of breadcrumbs; first as isFirst; last as isLast">
    <span *ngIf="!isFirst && breadcrumb.label">
        &raquo;
    </span>

    <span *ngIf="!isFirst && !isLast; else notDroppable"
          droppable
          [dropScope]="'item'"
          (onDrop)="this.onDragDrop(this.dragEvent,breadcrumb)"
          >
        <a routerLink="{{breadcrumb.url}}">{{breadcrumb.label}}</a>
    </span>

    <ng-template #notDroppable>
        <a routerLink="{{breadcrumb.url}}">{{breadcrumb.label}}</a>
    </ng-template>
</span>

